import React, { useState } from "react";
import { Modal, Button, Space, Spin, Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import dummyuser from "../assets/profile_placeholder.jpg";
import { toast } from 'react-toastify';

const UserProfileModal = ({ setIsLoginVisible, data, handleLogout: onLogout }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleLogout = () => {
    setLoading(true);
    setIsLoginVisible(false);
    
    // Call the parent handleLogout to update Navbar state immediately
    if (onLogout) onLogout();

    navigate("/");
    setTimeout(() => {
      setIsModalVisible(false);
      setLoading(false);
      toast.success('Logged out Successfully');
    }, 1000);
  };

  const isHashName = data?.full_name?.length >= 32 && !data?.full_name?.includes(" ");
  const displayName = isHashName && data?.email 
                      ? data.email.split("@")[0] 
                      : (data?.full_name || data?.fullName || "My Profile");

  return (
    <>
      <style>
        {`
          .ant-modal {
            border-radius: 12px;
            overflow: hidden;
          }
          .ant-modal-title {
            text-align: center;
            font-weight: bold;
          }
          .ant-btn-danger {
            background-color: #ff4d4f;
            border-color: #ff4d4f;
            font-weight: 500;
          }
        `}
      </style>

      <div
        onClick={showModal}
        style={{ color: "white", fontSize: "16px", fontWeight: "bold", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
        <Avatar src={dummyuser} size={35} />
        {displayName}
      </div>

      <Modal title="Profile" open={isModalVisible} onCancel={handleOk} footer={null} centered>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}>
            <Spin size="large" tip="Logging Out..." />
          </div>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 24 }}>
              {dummyuser ? (
                <Avatar src={dummyuser} size={100} style={{ marginBottom: 16 }} />
              ) : (
                <Avatar size={100} icon={<UserOutlined />} style={{ marginBottom: 16 }} />
              )}
              <h2 style={{ marginBottom: 8 }}>{displayName || "Guest User"}</h2>
              <p style={{ color: "gray" }}>{data?.email || "No email provided"}</p>
            </div>
            <Space
              style={{
                width: "100%",
                marginTop: 16,
                justifyContent: "center",
                display: "flex",
              }}>
              <Button type="primary" block>
                Manage Security Profile
              </Button>
              <Button type="primary" danger block onClick={handleLogout}>
                Logout
              </Button>
            </Space>
          </>
        )}
      </Modal>
    </>
  );
};

export default UserProfileModal;
